import { Brain, Activity, Target, Lightbulb, Settings } from 'lucide-react';
import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const tabs = [
  { id: 'capture', label: 'Capture', icon: Brain },
  { id: 'insights', label: 'Insights', icon: Lightbulb },
  { id: 'goals', label: 'Goals', icon: Target },
  { id: 'activity', label: 'Activity', icon: Activity },
];

export function Layout({ children, activeTab, onTabChange }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-gray-900 border-b border-gray-800 px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Brain className="w-8 h-8 text-brain-500" />
            <h1 className="text-xl font-semibold">Basement Brain</h1>
          </div>
          <button className="p-2 text-gray-400 hover:text-gray-200 transition-colors">
            <Settings className="w-5 h-5" />
          </button>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 px-4 py-6">
        <div className="max-w-4xl mx-auto">{children}</div>
      </main>

      {/* Bottom navigation */}
      <nav className="bg-gray-900 border-t border-gray-800 px-4 py-2 sticky bottom-0">
        <div className="max-w-4xl mx-auto flex justify-around">
          {tabs.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => onTabChange(id)}
              className={`flex flex-col items-center gap-1 py-2 px-4 rounded-lg transition-colors ${
                activeTab === id
                  ? 'text-brain-500 bg-brain-500/10'
                  : 'text-gray-400 hover:text-gray-200'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-xs font-medium">{label}</span>
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
}
